<template>
  <div
    class="time-change flex"
    :class="{ 'time-change-app': $route.name == 'Dashboard' }"
  >
    <div class="flex flex--column">
      <a @click="$emit('updateTimeStep', true)" class="time-change-arrow"></a>
      <a @click="$emit('updateTimeStep', false)" class="time-change-arrow"></a>
    </div>
    <img width="28" src="/assets/img/svg/zoom-in.svg" />
  </div>
</template>

<script>
export default {
  name: "TimeRangeArrows"
};
</script>
